import { useContext } from './context'
import { useSendCode } from './useSendCode'
import { ShowIf } from '@ztechapps/webui.util'
import { Form, InputGroup } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import React from 'react'

export const SendCode = () => {
  const context = useContext()
  const [showCodeInput] = context.showCodeInput
  const [destination, setDestination] = context.destination
  const [onSendCode, { loading: sending }] = useSendCode()

  return (
    <div>
      <ShowIf condition={!showCodeInput}>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            return onSendCode()
          }}
        >
          <InputGroup>
            <Form.Control
              type="text"
              id="destination"
              required
              value={destination}
              name="destination"
              onChange={(e) => setDestination(e?.target?.value)}
              autoComplete="off"
              placeholder="Email or mobile phone number"
              disabled={sending}
            />
            <BusyButton isBusy={sending} busyText="Sending..." onClick={onSendCode}>
              Send the code
            </BusyButton>
          </InputGroup>
        </form>
        <Form.Text>
          If the email or phone number that you entered exists from our database, we will send you there the code for
          login. Please wait for a few minutes until the code arrives to your phone or mailbox.
        </Form.Text>
      </ShowIf>
    </div>
  )
}
